export const EXPERIENCE_LANG_ITEM = 'experience-lang';
export const COMPANY_ID_ITEM = 'companyId';
export const COMPANIES_PAGE = 'companiesPage';
